import { FC } from "react";

import { FeatureMainTitleProps } from "./index.props";
import "./styles.scss";

export const FeatureMainTitle: FC<FeatureMainTitleProps> = ({ text }) => {
  return <span className="feature-main-title">{text}</span>;
};
